import merge from 'lodash/merge';
import themeConstants from '../static/react-injector/src/theme/theme-constants.json';

const themeOverrides = {
    colors: {
        poppy_red: '#F96661',
        dark_poppy_red: '#D85C57',
        light_poppy_red: '#FBC8C6',
        burnt_sienna: '#EC6661',
        grass_green: '#51C5A0',
        base_white: '#fff',
        base_grey: '#3A4B68',
        road_grey: '#44527B',
        road_grey_030: '#F9F9FB',
        road_grey_080: '#F0F2F5',
        road_grey_050: '#F5F6F8',
        road_grey_100: '#ECEEF2',
        road_grey_200: '#DADCE5',
        road_grey_300: '#C7CBD7',
        road_grey_400: '#B4BACA',
        road_grey_500: '#A1A8BD',
        road_grey_600: '#8F97B0',
        road_grey_700: '#7C86A3',
        road_grey_800: '#697595',
        road_grey_900: '#576388',
        road_grey_10p: 'rgba(68, 82, 123, 0.1)',
        road_grey_5p: 'rgba(68, 82, 123, 0.05);',
        brand_primary_blue: '#58B1FC',
        brand_primary_blue_dark: '#3097E1',
        brand_primary_blue_light: '#EBF5FC',
        primary_blue_light: '#EBF5FC',
        snow_white: '#FCFDFF',

        primary: 'steelblue',
        label: 'orangered',
        primary_button: 'red',
    },
    button: {
        base: {
            color: 'primary',
            bg: 'white',
            m: '10px',
            p: '5px',
        },

        primary: {
            color: 'white',
            bg: 'primary',
            border: 'solid 1px',
            borderColor: 'primary',
        },
        label: {
            base: {
                display: 'inline-block',
                pl: '10px',
                color: 'label',
            },
        },
    },
    screen: {
        /* Screen sizes (needs to be synced with variables.less) */
        xs: '480px',
        sm: '768px',
        md: '992px',
        lg: '1200px',
    },
    container: {
        /* For container queries */
        xs: '600px',
        sm: '700px',
        md: '800px',
        lg: '900px',
    },
};

export const theme: typeof themeOverrides = merge(themeConstants, themeOverrides);

export default theme;
